import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

const colorClasses = {
  neutral: cn('bg-background-secondary text-text-primary'),
  inverted: cn('bg-surface text-text-primary'),
  blue: cn('bg-entity-blue-muted text-entity-blue-foreground'),
  red: cn('bg-entity-red-muted text-entity-red-foreground'),
  yellow: cn('bg-entity-yellow-muted text-entity-yellow-foreground'),
  orange: cn('bg-entity-orange-muted text-entity-orange-foreground'),
  green: cn('bg-entity-green-muted text-entity-green-foreground'),
  purple: cn('bg-entity-purple-muted text-entity-purple-foreground'),
  pink: cn('bg-entity-pink-muted text-entity-pink-foreground'),
  proTier: cn('bg-tier-pro-muted text-tier-pro-text shadow-none'),
  beta: cn('bg-background-secondary font-medium text-text-secondary'),
} as const;

const sizeClasses = {
  xs: cn(
    'gap-0.5 px-1 py-0.5 text-[0.625rem] leading-[100%]',
    "[&_svg:not([class*='size-'])]:size-2.5"
  ),
  sm: cn(
    'gap-1 rounded-md px-1.5 py-1 text-[0.75rem] leading-[100%]',
    "[&_svg:not([class*='size-'])]:size-3"
  ),
  md: cn(
    'gap-1 rounded-md px-1.5 py-1 text-[0.875rem] leading-[100%]',
    "[&_svg:not([class*='size-'])]:size-3.5"
  ),
  lg: cn(
    'gap-1 rounded-md px-2 py-1 text-[1rem] leading-[100%]',
    "[&_svg:not([class*='size-'])]:size-3.5"
  ),
  /**
   * Source control badge size.
   *
   * Match `Button` size="sm" height + horizontal padding for alignment in the chat input row.
   */
  source: cn(
    'h-8 gap-1 px-2.5 py-2 text-xs font-medium leading-none',
    "[&_svg:not([class*='size-'])]:size-3.5"
  ),
} as const;

const badgeVariants = cva(
  cn(
    'inline-flex h-fit items-center gap-2 rounded-sm bg-transparent font-medium transition-colors [&_svg]:shrink-0',
    focusRing
  ),
  {
    variants: {
      color: colorClasses,
      size: sizeClasses,
    },
    defaultVariants: {
      color: 'neutral',
      size: 'lg',
    },
  }
);

export { badgeVariants, colorClasses, sizeClasses };
